import React, { useEffect, useState, useRef } from 'react'
import styles from './hero.module.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getAllCategoriesThunk, setCategories } from '../../../../redux/category/getAllCategorySlice'
import { stripHtmlTags } from '../../../../utils/utils'
import { fetchMainSearch, formatStock, getExcessManufacturer } from '../../../../utils/mainSearch'
import { setExcessSearch } from '../../../../redux/excessSlice'

const Hero = ({ herobanner }) => {
    const heroRef = useRef(null);
    const { categories, loading, error, filteredCategories } = useSelector((state) => state.categories);

    const [suggestedData, setSuggestedData] = useState([])
    const [excessData, setExcessData] = useState([])

    const clearSuggestions = () => {
        setSuggestedData([]);
        setExcessData([]);
    };

    const navigate = useNavigate()
    const [search, setSearch] = useState('')
    const dispatch = useDispatch()

    const placeholders = [
        "Search Microcontrollers...",
        "Search Arduino...",
        "Search STM32...",
        "Search Raspberry Pi..."
    ];
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const [placeholderText, setPlaceholderText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);

    const searchWrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchWrapperRef.current && !searchWrapperRef.current.contains(event.target)) {
                clearSuggestions();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        let timer;
        const currentFullText = placeholders[placeholderIndex];
        const delay = isDeleting ? 40 : 80;

        const handleTyping = () => {
            if (!isDeleting) {
                setPlaceholderText(currentFullText.slice(0, placeholderText.length + 1));
                if (placeholderText.length + 1 === currentFullText.length) {
                    timer = setTimeout(() => setIsDeleting(true), 2200);
                    return;
                }
            } else {
                setPlaceholderText(currentFullText.slice(0, placeholderText.length - 1));
                if (placeholderText.length === 0) {
                    setIsDeleting(false);
                    setPlaceholderIndex((prev) => (prev + 1) % placeholders.length);
                    return;
                }
            }
            timer = setTimeout(handleTyping, delay);
        };

        timer = setTimeout(handleTyping, delay);
        return () => clearTimeout(timer);
    }, [placeholderText, isDeleting, placeholderIndex]);

    const searchCategory = async (e) => {
        if (e) e.preventDefault()
        clearSuggestions()
        if (search && search.trim()) {
            navigate(`/categories?search=${encodeURIComponent(search.trim())}`)
        }
    }

    const latestQueryRef = useRef('');
    const debounceTimerRef = useRef(null);

    const smartSearch = (text) => {
        setSearch(text);
        latestQueryRef.current = text;
        if (!text.trim()) {
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
            clearSuggestions();
            return;
        }
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = setTimeout(async () => {
            const currentQuery = text.trim();
            try {
                const { suggestions, excessItems } = await fetchMainSearch(currentQuery);
                if (latestQueryRef.current.trim() === currentQuery) {
                    setSuggestedData(suggestions);
                    setExcessData(excessItems);
                }
            } catch (err) {
                console.log(err);
            }
        }, 180);
    };

    const handlecatclick = (data) => {
        clearSuggestions()
        if (data?.type == "level3") {
            navigate(`/productList/${data?.name}`)
        } else {
            navigate(`/categories?search=${encodeURIComponent(data?.name)}`)
        }
    }

    const getCleanUrl = (url) => {
        if (!url) return '';
        if (url.includes('asset.electrowiz.in')) {
            return url.replace('https://asset.electrowiz.in', 'https://electrowiz-ap.s3.ap-south-1.amazonaws.com');
        }
        return url;
    };

    // Excess results open the Excess Inventory page searched for that part
    const handleExcessClick = (item) => {
        clearSuggestions()
        dispatch(setExcessSearch(item?.productNumber || ''))
        navigate('/exInventoryBuyItem')
    }

    const handleClickonsearch = (e) => {
        if (e) e.preventDefault()
        clearSuggestions()
        if (search && search.trim()) {
            navigate(`/categories?search=${encodeURIComponent(search.trim())}`)
        }
    }

    return (
        <div ref={heroRef} className={styles.headerContainer}>
            <div className={styles.heroMain}>
                <div className={styles.overlay}></div>
                {herobanner?.assets?.url ? (
                    herobanner.assets.type === "IMAGE" ? (
                        <img src={getCleanUrl(herobanner.assets.url)} alt="Hero Banner" />
                    ) : (
                        <video
                            controls={false}
                            autoPlay
                            loop
                            key={getCleanUrl(herobanner.assets.url)}
                            muted
                            style={{ width: '100%', height: "85vh", objectFit: 'cover' }}
                        >
                            <source src={getCleanUrl(herobanner.assets.url)} type="video/mp4" />
                        </video>
                    )
                ) : (
                    <div className={styles.fallbackBg}></div>
                )}
                <div className={styles.heroContent}>
                    <p >{herobanner?.bannerTitle}</p>
                    <div ref={searchWrapperRef} className={styles.searchWrapper}>
                        <form onSubmit={(e) => { e.preventDefault(); handleClickonsearch(); }} className={styles.searchForm}>
                            <div className={styles.searchBarWrapper}>
                                <span className={styles.searchIcon}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder={placeholderText}
                                    className={styles.searchInput}
                                    value={search}
                                    onChange={(e) => smartSearch(e.target.value)}
                                />
                                
                                
                                <button type="submit" className={styles.searchBtn} onClick={() => handleClickonsearch()}>
                                    Search
                                </button>
                                
                                {(suggestedData.length > 0 || excessData.length > 0) &&
                                    <div className={styles.searchBox}>
                                        <ul>
                                            {
                                                suggestedData.map((i, idx) => (
                                                    <React.Fragment key={idx}>
                                                        {i?.type != "product" ? (
                                                            <li onClick={() => handlecatclick(i)} className={styles.heroSearchItem}>
                                                                <span className={styles.heroSuggestionIcon}>📦</span>
                                                                <div className={styles.heroSuggestionMeta}>
                                                                    <span className={styles.heroSuggestionTitle}>{i?.name}</span>
                                                                </div>
                                                            </li>
                                                        ) : (
                                                            <li onClick={() => navigate(`/ProductCode/${i?.name}`)} className={styles.heroSearchItem}>
                                                                {i?.image ? (
                                                                    <img src={getCleanUrl(i.image)} alt={i.name} className={styles.heroSuggestionImage} />
                                                                ) : (
                                                                    <span className={styles.heroSuggestionIcon}>⚡</span>
                                                                )}
                                                                <div className={styles.heroSuggestionMeta}>
                                                                    <span className={styles.heroSuggestionTitle}>
                                                                        Part: {i?.name}{(i?.manufacturer?.[0]?.name || i?.productOverview?.manufacturer?.[0]?.name) ? ` | ${i?.manufacturer?.[0]?.name || i?.productOverview?.manufacturer?.[0]?.name}` : ''}
                                                                    </span>
                                                                    {(i?.description || i?.productOverview?.description) && (
                                                                        <span className={styles.heroSuggestionDescription}>
                                                                            {stripHtmlTags(i?.description || i?.productOverview?.description)}
                                                                        </span>
                                                                    )}
                                                                    {i?.inventory?.qtyAvailable !== undefined && (
                                                                        <span className={styles.heroSuggestionStock}>{formatStock(i?.inventory?.qtyAvailable)}</span>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                            }
                                {excessData.length > 0 && (
                                    <>
                                        <li className={styles.heroSuggestionSection}>Available in Excess Inventory</li>
                                        {excessData.map((item) => {
                                            const mfg = getExcessManufacturer(item);
                                            return (
                                                <li key={`excess-${item?._id}`} onClick={() => handleExcessClick(item)} className={styles.heroSearchItem}>
                                                    <span className={styles.heroSuggestionIcon}>♻️</span>
                                                    <div className={styles.heroSuggestionMeta}>
                                                        <span className={styles.heroSuggestionTitle}>
                                                            Part: {item?.productNumber}{mfg ? ` | ${mfg}` : ''}
                                                        </span>
                                                        <span className={styles.heroSuggestionStock}>{formatStock(item?.stock)}</span>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </>
                                )}
                                        </ul>
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={styles.toolExplore}>
                <p>
                    Tools to explore on <span className={styles.purpleText}>Electrowiz</span>
                </p>
                <button 
                    onClick={() => {
                        // Land on the "Tools to explore" heading, just below the sticky header
                        const heading = heroRef.current?.querySelector(`.${styles.toolExplore}`);
                        if (heading) {
                            const top = heading.getBoundingClientRect().top + window.scrollY - 200;
                            window.scrollTo({ top, behavior: 'smooth' });
                        }
                    }}
                    className={styles.exploreArrowBtn}
                    title="Scroll down"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <polyline points="19 12 12 19 5 12"></polyline>
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Hero